import { useId as u } from "react";
function n(o, r) {
  return `${o}-${r}`;
}
function f({
  id: o,
  hasDescription: r = !1,
  isError: t = !1
}) {
  const s = u(), e = o ?? s, c = n(e, "label"), d = n(e, "description"), i = n(e, "error"), l = [t && i, r && d].filter(Boolean).join(" ") || void 0;
  return {
    id: e,
    labelId: c,
    descriptionId: d,
    errorId: i,
    describedBy: l
  };
}
export {
  f as useFieldIds
};
